import Vue from 'vue';
import VS2 from 'vue-script2';
import moment from 'moment';
import * as utils from 'core/utils';
import Vuelidate from 'vuelidate';
import { G2S } from 'core/g2s';
import router from './router';
import Directives from './directives';
import VApp from 'vuetify/es5/components/VApp';
import VAutocomplete from 'vuetify/es5/components/VAutocomplete';
import VBottomSheet from 'vuetify/es5/components/VBottomSheet';
import VBtn from 'vuetify/es5/components/VBtn';
import VBtnToggle from 'vuetify/es5/components/VBtnToggle';
import VCard from 'vuetify/es5/components/VCard';
import VCarousel from 'vuetify/es5/components/VCarousel';
import VCheckbox from 'vuetify/es5/components/VCheckbox';
import VDataTable from 'vuetify/es5/components/VDataTable';
import VDatePicker from 'vuetify/es5/components/VDatePicker';
import VDialog from 'vuetify/es5/components/VDialog';
import VExpansionPanel from 'vuetify/es5/components/VExpansionPanel';
import VExpansionPanelContent from 'vuetify/es5/components/VExpansionPanel';
import VInput from 'vuetify/es5/components/VInput';
import VMenu from 'vuetify/es5/components/VMenu';
import VProgressCircular from 'vuetify/es5/components/VProgressCircular';
import VProgressLinear from 'vuetify/es5/components/VProgressLinear';
import VRating from 'vuetify/es5/components/VRating';
import VRangeSlider from 'vuetify/es5/components/VRangeSlider';
import VSelect from 'vuetify/es5/components/VSelect';
import VSlider from 'vuetify/es5/components/VSlider';
import VTextarea from 'vuetify/es5/components/VTextarea';
import VTextField from 'vuetify/es5/components/VTextField';
import VTooltip from 'vuetify/es5/components/VTooltip';
import Vuetify from 'vuetify/es5/components/Vuetify';
import PortalVue from 'portal-vue';
import { AlphabeticalSearchListComponent } from './components/alphabetical-search-list';
import { ButtonSocialShareFacebookComponent } from './components/button-social/share-facebook';
import { ButtonSocialShareVkontakteComponent } from './components/button-social/share-vkontakte';
import { CheapestTicketsSearchComponent } from './components/cheapest-tickets-search';
import { CustomCarouselComponent } from './components/custom-carousel';
import { StoryCarouselComponent } from './components/story-carousel';
import { CustomIconComponent } from './components/custom-icon';
import { DialogContentComponent } from './components/dialog/content';
import { DialogCatchUpComponent } from './components/dialog/catch-up';
import { DialogMessageComponent } from './components/dialog/message';
import { FullScreenDialogComponent } from './components/dialog/full-screen';
import { FlightDetailsComponent } from './components/flight/details';
import { FlightSearchFormComponent } from './components/flight/search-form';
import { FlightTermsComponent } from './components/flight/terms';
import { FlightVariantsComponent } from './components/flight/variants';
import { GdprNotificationComponent } from './components/gdpr-notification';
import { HotTicketsSearchComponent } from './components/hot-tickets-search';
import { LanguageDropdownComponent } from './components/language-dropdown';
import { RegionSelectorComponent } from './components/header-region-selector';
import { PanelBannerComponent } from './components/panel/banner';
import { PanelPromoComponent } from './components/panel/promo';
import { PanelSigninComponent } from './components/panel/signin';
import { PanelSupportComponent } from './components/panel/support';
import { ProductInsurancesComponent } from './components/product/insurances';
import { ProductNotInsuranceListComponent } from './components/product/not-insurance-list';
import { ProductServiceComponent } from './components/product/service';
import { SeatsSelectionComponent } from './components/flight/seats-selection';
import { SearchTabsComponent } from './components/flight/search-tabs';
import { ProductServiceBrandComponent } from './components/product/service-brands';
import { AdvancedProductServiceBrandComponent } from './components/product/advanced-service-brands';
import { ProductPackageComponent } from './components/product/package';
import { ProductTimerComponent } from './components/product/timer';
import { OnlineRegistrationComponent } from './components/product/online-registration';
import { ToastComponent } from './components/toast';
import transitions from 'vuetify/es5/components/transitions';
import directives from 'vuetify/es5/directives';
import { createSimpleTransition } from 'vuetify/es5/util/helpers';
import { GridBreakpoints } from './constants/breakpoints';
import { AdditionalBaggageComponent } from './components/flight/additional-baggage';

G2S.init();

Vue.use(<any>Vuelidate);
Vue.use(<any>VS2);

Vue.use(Vuetify,
    {
        theme: false,
        breakpoint: {
            thresholds: {
                xs: GridBreakpoints.sm,
                sm: GridBreakpoints.md,
                md: GridBreakpoints.lg,
                lg: GridBreakpoints.xl
            },
            scrollbarWidth: 0
        },
        components: {
            VApp,
            VAutocomplete,
            VBottomSheet,
            VBtn,
            VBtnToggle,
            VCard,
            VCarousel,
            VCheckbox,
            VDataTable,
            VDatePicker,
            VDialog,
            VExpansionPanel,
            VExpansionPanelContent,
            VInput,
            VMenu,
            VProgressCircular,
            VProgressLinear,
            VRating,
            VRangeSlider,
            VSelect,
            VSlider,
            VTextarea,
            VTextField,
            VTooltip,
            transitions
        },
        directives,
        icons: {
            'complete': '',
            'cancel': '',
            'close': '',
            'delete': '', // delete (e.g. v-chip close)
            'clear': '',
            'success': '',
            'info': '',
            'warning': '',
            'error': '',
            'prev': 'el-icon-arrow-left',
            'next': 'el-icon-arrow-right',
            'checkboxOn': '',
            'checkboxOff': '',
            'checkboxIndeterminate': '',
            'delimiter': '', // for carousel
            'sort': '',
            'expand': 'el-icon-arrow-down',
            'menu': '',
            'subgroup': '',
            'dropdown': 'el-icon-arrow-down',
            'radioOn': '',
            'radioOff': '',
            'edit': ''
        }
    });
Vue.use(PortalVue);

Vue.component('v-alphabetical-search-list', AlphabeticalSearchListComponent as any);
Vue.component('v-button-social-share-facebook', ButtonSocialShareFacebookComponent as any);
Vue.component('v-button-social-share-vkontakte', ButtonSocialShareVkontakteComponent as any);
Vue.component('v-cheapest-tickets-search', CheapestTicketsSearchComponent as any);
Vue.component('v-custom-carousel', CustomCarouselComponent as any);
Vue.component('v-story-carousel', StoryCarouselComponent as any);
Vue.component('v-custom-icon', CustomIconComponent as any);
Vue.component('v-dialog-content', DialogContentComponent as any);
Vue.component('v-dialog-catch-up', DialogCatchUpComponent as any);
Vue.component('v-dialog-message', DialogMessageComponent as any);
Vue.component('v-full-screen-dialog', FullScreenDialogComponent as any);
Vue.component('v-flight-details', FlightDetailsComponent as any);
Vue.component('v-flight-search-form', FlightSearchFormComponent as any);
Vue.component('v-flight-terms', FlightTermsComponent as any);
Vue.component('v-flight-variants', FlightVariantsComponent as any);
Vue.component('v-gdpr-notification', GdprNotificationComponent as any);
Vue.component('v-hot-tickets-search', HotTicketsSearchComponent as any);
Vue.component('v-language-dropdown', LanguageDropdownComponent as any);
Vue.component('v-region-selector', RegionSelectorComponent as any);
Vue.component('v-panel-banner', PanelBannerComponent as any);
Vue.component('v-panel-promo', PanelPromoComponent as any);
Vue.component('v-panel-signin', PanelSigninComponent as any);
Vue.component('v-panel-support', PanelSupportComponent as any);
Vue.component('v-product-insurances', ProductInsurancesComponent as any);
Vue.component('v-product-not-insurance-list', ProductNotInsuranceListComponent as any);
Vue.component('v-seats-selection', SeatsSelectionComponent as any);
Vue.component('v-search-tabs', SearchTabsComponent as any);
Vue.component('v-product-service', ProductServiceComponent as any);
Vue.component('v-product-service-brand', ProductServiceBrandComponent as any);
Vue.component('v-advanced-product-service-brand', AdvancedProductServiceBrandComponent as any);
Vue.component('v-product-package', ProductPackageComponent as any);
Vue.component('v-product-timer', ProductTimerComponent as any);
Vue.component('v-product-registration', OnlineRegistrationComponent as any);
Vue.component('v-toast', ToastComponent as any);
Vue.component('v-additional-baggage', AdditionalBaggageComponent as any);

const carouselSlideTransition = createSimpleTransition('carousel-slide-transition');
const carouselSlideReverseTransition = createSimpleTransition('carousel-slide-reverse-transition');
const slideXTransition = createSimpleTransition('slide-x-transition');
const slideXReverseTransition = createSimpleTransition('slide-x-reverse-transition');

Vue.component('carousel-slide-transition', carouselSlideTransition);
Vue.component('carousel-slide-reverse-transition', carouselSlideReverseTransition);
Vue.component('v-slide-x-transition', slideXTransition);
Vue.component('v-slide-x-reverse-transition', slideXReverseTransition);

Vue.directive('display-toggle', Directives.DisplayToggleDirective);
Vue.directive('navbar-collapse', Directives.NavbarCollapseDirective);
Vue.directive('go-first-child-link', Directives.GoFirstChildLink);
Vue.directive('hidden-link', Directives.HiddenLink);

const root = new Vue({
    el: '#app',
    router,
    data: () => {
        return {
            megoForYouMenuInNavBarIsVisible: false,
            megoPopupMainIsVisible: false
        };
    },
    mounted() {
        window.setTimeout(() => {
            this.tryToShowMegoPopupMain();
        }, 1000);
    },
    methods: {
        toggleMegoForYouMenuInNavBar: () => {
            if (root['$vuetify'].breakpoint.smAndDown) {
                root.megoForYouMenuInNavBarIsVisible = !root.megoForYouMenuInNavBarIsVisible;
            }
        },
        tryToShowMegoPopupMain() {
            if (utils.Cookies.omitPromoPopupGet('mego_main_dec_2019') != 'true'
                && moment().isAfter(moment('01.12.2019', 'DD.MM.YYYY'))
                && moment().isBefore(moment('01.01.2020', 'DD.MM.YYYY'))) {
                this.megoPopupMainIsVisible = true;
            }

        },
        onMegoPopupMainCloseClick() {
            this.megoPopupMainIsVisible = false;
            utils.Cookies.omitPromoPopupSet('mego_main_dec_2019', '31.12.2019');
        }
    }
});

window['ROOT'] = root;
window['moment'] = moment;
